/*
 * @Author: DQL
 * @Date: 2020-03-09 17:00:31
 * @LastEditors: DQL
 * @LastEditTime: 2022-10-02 14:15:27
 * @Description: file content
 */
import axios from 'axios';
import config from '@/config';

const { commontCtx, authCtx } = config;
const { iffApi } = config.ctx;

// 登录认证
export const loginSys = (params) => { return axios.post(`${authCtx}/auth/security/login`, params).then(rsp => rsp); };

// 当前用户菜单列表
export const getUserMenus = () => { return axios.get(`${commontCtx}/menu/currentUser/menu/tree`); };

// 退出
export const logoutSys = () => { return axios.post(`${authCtx}/auth/security/logout`); };

// 获取身份信息
export const getSubject = () => { return axios.get(`${authCtx}/auth/security/info`); };

// 获取系统枚举
export const getEnum = () => { return axios.get(`${commontCtx}/enums`); };

// 切换身份
export const changeSubject = (capacityCode) => { return axios.post(`${authCtx}/auth/security/switch?capacityCode=${capacityCode}`); };

// 获取用户授权的的页面元素
export const getRoleElement = () => { return axios.get(`${commontCtx}/role/element`); };

// 密码强度校验
export const passwordCheck = (password) => { return axios.post(`${commontCtx}/admin/password/check`, password); };

// 密码修改
export const changepwd = (fd) => { return axios.put(`${commontCtx}/person/changepwd`, fd); };

// 机构部门（无权限）
export const getDeptTree = (params) => { return axios.get(`${commontCtx}/dept/getDepts`, { params: params }); };

/* =======================================
   业务枚举服务start
*/
export const getIffEnum = () => { return axios.get(`${iffApi}/enums`); };

// 当前登录身份的岗位分类，用于进入江西消防或既有业务首页
export const getCurrentRoleType = () => { return axios.get(`${iffApi}/common/current-role-type`); };

// 获取环境变量
export const getEnvInfo = (envId) => { return axios.get(`${iffApi}/env/getEnvInfo/${envId}`); };

/* 业务枚举服务end */

export const systemPreloadInfo = () => {
  // 调用 getExamplesApiEnum 业务枚举
  return axios.all([getSubject(), getEnum(), getRoleElement(), getUserMenus(), getIffEnum(), getCurrentRoleType()]);
};

// 图片验证码
export const kaptchaService = {
  // 获取验证码
  getCode: () => { return axios.get(`${commontCtx}/kaptcha`); },
  // 校验图片验证码
  codeValid: (code) => { return axios.post(`${commontCtx}/kaptcha/${code}`); }
};

// 注册
export const registerService = {
  // 注册
  register: (fd) => { return axios.post(`${commontCtx}/register`, fd).then(rsp => rsp); },

  // 激活账号
  activate: (params) => { return axios.get(`${commontCtx}/register`, { params: params }); },

  // 检查用户名是否重复
  validUserName: (fd) => { return axios.post(`${commontCtx}/register/isRepeatUsername`, fd); },

  // 检查账号是否重复
  validuserCode: (fd) => { return axios.post(`${commontCtx}/register/isRepeatUsercode`, fd); },

  // 检查邮箱是否重复
  validuserEmail: (params) => { return axios.get(`${commontCtx}/user/isRepeatEmail`, { params: params }); },

  // 检查密码强度
  validPassword: (fd) => { return axios.post(`${commontCtx}/register/passwordStrength`, fd); }
};
